import { useState, forwardRef, useImperativeHandle, useMemo } from "react";
import { Dialog } from "@xp-design/mobile";
import style from "./style.module.less";
import { processOssImage } from "@/utils/image";

interface PrizeDialogProps {
  onClose: () => void;
  prizeData: {
    isWin: boolean;
    productName?: string;
    prizeUrl?: string;
    winBg?: string;
    noWinBg?: string;
    singleDistributionCount?: number;
  };
}

const PrizeDialog = forwardRef<
  {
    onOpen: () => void;
    onClose: () => void;
  },
  PrizeDialogProps
>(({ onClose }, ref) => {
  const [visible, setVisible] = useState(false);
  const [prizeData, setPrizeData] = useState<PrizeDialogProps["prizeData"]>({} as PrizeDialogProps["prizeData"]);

  const handleOpen = (data: PrizeDialogProps["prizeData"]) => {
    setVisible(true);
    setPrizeData(data);
  };

  const handleClose = () => {
    setVisible(false);
    onClose?.();
  };

  useImperativeHandle(ref, () => ({
    onOpen: handleOpen,
    onClose: handleClose,
  }));

  const bgUrl = useMemo(
    () => (prizeData.isWin ? prizeData.winBg : prizeData.noWinBg),
    [prizeData.isWin, prizeData.winBg, prizeData.noWinBg],
  );

  return (
    <Dialog
      visible={visible}
      onClose={handleClose}
      getContainer={null}
      closeOnMaskClick={false}
      bodyClassName={style["customDialogBody"]}
      content={
        <>
          <div className={style["prizeDialog"]}>
            <div className={style["prizeDialogTitle"]}>
              {prizeData.isWin ? "恭喜中奖啦！" : "很遗憾~"}
            </div>
            <div
              className={style["prizeDialogContent"]}
              style={{
                backgroundImage: `url(${processOssImage(bgUrl)})`,
                backgroundSize: "100% 100%",
              }}
            >
              {/* 奖品名称 */}
              <div className={style["prizeDialogPrizeName"]}>
                {prizeData.isWin
                  ? `${prizeData.productName}`
                  : "您与奖品擦肩而过 \n 继续努力"}
              </div>
              {/* 奖品图片 */}
              <div className={style["prizeDialogPrizeContainer"]}>
                <div
                  className={style["prizeDialogPrizeImg"]}
                  style={{
                    backgroundImage: `url(${processOssImage(prizeData.prizeUrl)})`,
                    backgroundSize: "100% 100%",
                  }}
                />
                {prizeData.isWin && (
                  <div className={style["countNum"]}>
                    {" "}
                    X {prizeData.singleDistributionCount || 1}
                  </div>
                )}
              </div>
              <div className={style["prizeDialogBtnBg"]}>
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    handleClose?.();
                  }}
                >
                  {prizeData.isWin ? "" : ""}
                </div>
              </div>
            </div>
          </div>
        </>
      }
    ></Dialog>
  );
});

export default PrizeDialog;
